import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

const DEFAULT_SITE = 'ap2.datadoghq.com';
const DEFAULT_SERVICE = 'surpassin-super-admin-web';
const DEFAULT_SESSION_SAMPLE_RATE = 100;
const DEFAULT_SESSION_REPLAY_SAMPLE_RATE = 20;
const DEFAULT_PRIVACY_LEVEL = 'mask-user-input';

let hasInitialized = false;

const parseBoolean = (value, fallback) => {
  if (value === undefined || value === null || value === '') return fallback;
  return String(value).toLowerCase() === 'true';
};

const parseNumber = (value, fallback) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const initDatadogRum = () => {
  if (hasInitialized) return;

  const enabled = parseBoolean(import.meta.env.VITE_DATADOG_ENABLED, false);
  if (!enabled) return;

  const applicationId = import.meta.env.VITE_DATADOG_APPLICATION_ID;
  const clientToken = import.meta.env.VITE_DATADOG_CLIENT_TOKEN;

  if (!applicationId || !clientToken) {
    console.warn(
      '[Datadog RUM] Missing VITE_DATADOG_APPLICATION_ID or VITE_DATADOG_CLIENT_TOKEN. Skipping initialization.'
    );
    return;
  }

  const enableRouterPlugin = parseBoolean(
    import.meta.env.VITE_DATADOG_ENABLE_REACT_ROUTER_PLUGIN,
    true
  );
  const shouldStartSessionReplay = parseBoolean(
    import.meta.env.VITE_DATADOG_START_SESSION_REPLAY_RECORDING,
    false
  );

  const config = {
    applicationId,
    clientToken,
    site: import.meta.env.VITE_DATADOG_SITE || DEFAULT_SITE,
    service: import.meta.env.VITE_DATADOG_SERVICE || DEFAULT_SERVICE,
    env: import.meta.env.VITE_DATADOG_ENV || import.meta.env.MODE,
    sessionSampleRate: parseNumber(
      import.meta.env.VITE_DATADOG_SESSION_SAMPLE_RATE,
      DEFAULT_SESSION_SAMPLE_RATE
    ),
    sessionReplaySampleRate: parseNumber(
      import.meta.env.VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE,
      DEFAULT_SESSION_REPLAY_SAMPLE_RATE
    ),
    defaultPrivacyLevel:
      import.meta.env.VITE_DATADOG_DEFAULT_PRIVACY_LEVEL || DEFAULT_PRIVACY_LEVEL,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    silentMultipleInit: true,
    plugins: enableRouterPlugin ? [reactPlugin({ router: true })] : [],
  };

  const version = import.meta.env.VITE_DATADOG_VERSION;
  if (version) config.version = version;

  datadogRum.init(config);

  if (shouldStartSessionReplay) {
    datadogRum.startSessionReplayRecording();
  }

  hasInitialized = true;
};
